export const spacing = {
  sm: 1,
  md: 2,
  lg: 4,
  xl: 8
} as const;
